module.exports = __webpack_public_path__ + "img/prev.0b58bdee.svg";